import $ from 'jquery';

import {findOpenModal} from 'ui-library/modals/Modal';

/**
 * Returns true iff the specified DOM node has lost focus because a modal is active. Returns false if the
 * the DOM node is part of the modal itself.
 *
 * @param domNode the node to test, defaulting to the entire page if omitted
 * @returns true iff the specified DOM node has lost focus because a modal is active
 */
export default function isFocusSupercededByModal(domNode?: Element): boolean {
  const activeModal = findOpenModal();
  if (!activeModal) {
    return false;
  }

  return !domNode || $(domNode).closest('.modal').length === 0;
}
